import { useQuery } from '@tanstack/react-query'
import { type ErrorComponentProps, Link } from '@tanstack/react-router'
import { Bug } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@shadcn/button'

import { querySession } from '@api/session/session.queries'

import CopyButton from '../copy-button/copy-button'

const ErrorComponent = ({ error }: ErrorComponentProps) => {
  const { t } = useTranslation()
  const { data: session } = useQuery(querySession())

  const devText = [
    `URL\n${window.location.href}`,
    `ERROR\n${error.message}`,
    `STACK\n${error.stack}`,
    `SESSION\n${JSON.stringify(session, null, 2)}`,
  ].join('\n\n')

  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-6 py-12">
      <div className="flex items-center gap-2">
        <Bug className="text-fg-brand-primary-600 size-8" />
        <span className="text-lg font-semibold">
          {t('error-component.title')}
        </span>
      </div>
      <div className="flex flex-row items-center gap-6">
        <CopyButton
          text={devText}
          label={t('error-component.copy-button')}
          className="size-8 shrink-0 animate-bounce"
        />
        <span className="max-w-[30em] text-2xl font-bold text-gray-700">
          {t('error-component.description')}
        </span>
      </div>
      <Link to={session ? '/app/dashboard' : '/session/login'}>
        <Button size="ghost" variant="ghostPrimary">
          {t('not-found.button')}
        </Button>
      </Link>
    </div>
  )
}

export default ErrorComponent
